/*
Sohel 01/09/2023 2698951347 Implemented Copy Functionality
Sohel 01/18/2023 2698951347 Fixed Payload Issue
Sohel 01/02/2023 2698951347 fixed code uppercase issue
Rohini 03/02/2023 2698951347 commented input props
sohel 03/06/2023 2698951347 Added validation message for existing value
Ravi 06/23/2023 2698951347 fixed submit issue
Gireesh 11/12/2023 2698951347 added code and description validations
*/
import React, {useContext, useEffect, useRef} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from './../../../../../components/PageLoader/index';
import BreadCrums from '../../../../../util/BreadCrum';
import {fetchAllDataManagerCode, postCopy} from '../../../../../redux/reducers/DataManager';
import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
const CopyDataManager = ({oldDmCodeData, type}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {postCopyLoading, allDataManagerCode} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
  };
  const codeRef = useRef();
  const checkCodeExist = (value) => {
    if (allDataManagerCode && allDataManagerCode?.length > 0 && value) {
      const ar = [];
      allDataManagerCode.filter((i) => {
        if ((i?.dmCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) && i?.isActive === 'Y') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkDataMangerCodeAlreadyExist = (value) => {
    if (allDataManagerCode && allDataManagerCode?.length > 0 && value) {
      const ar = [];
      allDataManagerCode.filter((i) => {
        if ((i?.dmCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) && i?.isActive === 'N') {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const schema = Yup.object().shape({
    code: Yup.string()
      .required(`${type} Name is required`)
      .test('code', `${type} Name already exist`, (value) => !checkCodeExist(value))
      .test('code', `${type} Name has already been used in the past`, (value) => !checkDataMangerCodeAlreadyExist(value)),

    description: Yup.string()
      .test('description', 'Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Description is required'),
  });
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        dmCode: values?.code ? values?.code : '',
        dmDescription: values?.description ? values?.description : '',
        oldDmCode: oldDmCodeData?.dmCode ? oldDmCodeData?.dmCode : '',
        tabType: type,
        oldDataManagerId: oldDmCodeData?.dataManagerId ? oldDmCodeData?.dataManagerId : 0,
      };
      dispatch(postCopy(data));
    }
  };
  useEffect(() => {
    dispatch(fetchAllDataManagerCode(type));
  }, []);

  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={`Name`}
                    code={oldDmCodeData?.dmCode}
                    description={'Description'}
                    descriptionValue={oldDmCodeData?.dmDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder={`Enter ${type} Name`}
                              margin="dense"
                              name="code"
                              variant="outlined"
                              value={values?.code}
                              inputRef={codeRef}
                              label={`${type} Name`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              inputProps={{maxLength: 25}}
                              required
                              onBlur={handleBlur}
                              onChange={(e) => {
                                // const value = upperCaseCode(codeRef);
                                const value = currsorCodeIssue(codeRef);
                                setFieldValue('code', value);
                              }}
                              touched={touched.code}
                              error={Boolean(errors.code && touched.code)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.code && errors.code}
                            </FormHelperText>
                          </Grid>

                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Description"
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label="Description"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              inputProps={{maxLength: 100}}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFieldValue('description', e.target.value);
                              }}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                        disabled={enabledSubmission}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {postCopyLoading && <PageLoader />}
    </>
  );
};

export default CopyDataManager;
